import { useTranslation } from 'react-i18next'

import { SYMBOL_HYPHEN } from '../../../../constants/common'
import { formatDurationSeconds } from '../../../../utils/date'
import Text from '../../../Text'
import { Widget } from '../../../Widget'
import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'

import * as styles from './RequestProfileWidgetTimeTracking.module.css'

function RequestProfileWidgetTimeTracking({ completionTime, isSkeleton }) {
  const { t } = useTranslation()

  return (
    <Widget
      contentContainerProps={{
        className: styles.content,
        skeletonProps: { className: styles.skeleton },
      }}
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: null,
          },
        },
      }}
      isSkeleton={isSkeleton}
      qaName={RequestProfileWidgetKey.TIME_TRACKING}
      title={t('RequestProfile.TimeTrackingWidgetTitleKey')}
    >
      <div className={styles.field}>
        <Text isSecondary className={styles.label}>
          {t('RequestProfile.TimeTrackingWidgetCompletionTimeLabelKey')}
        </Text>
        <Text className={styles.value}>
          {formatDurationSeconds(completionTime) ?? SYMBOL_HYPHEN}
        </Text>
      </div>
    </Widget>
  )
}

export default RequestProfileWidgetTimeTracking
